const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

interface StoryLike {
    id?: string | number;
    story_number?: string | null;
    external_story_number?: string | null;
    title?: string | null;
    name?: string | null;
}

/**
 * Header title for the Feature Studio story view. Uses the human-facing story
 * number (or Jira key) — never the raw ai.user_stories UUID primary key.
 */
export function formatStoryHeaderTitle(story: StoryLike): string {
    const name = story.title || story.name || "";
    const candidate = story.story_number || story.external_story_number || "";
    if (!candidate || UUID_RE.test(candidate)) return name;
    return `${candidate} — ${name}`;
}
